import { useState } from 'react';
import './Testimonials.css';
import testimonials from '../data/testimonials';

export default function Testimonials() {
  const [index, setIndex] = useState(0);
  const total = testimonials.length;
  const active = testimonials[index];

  const prev = () => setIndex(i => (i - 1 + total) % total);
  const next = () => setIndex(i => (i + 1) % total);

  return (
    <section id="testimonials" className="tsm-section">
      <div className="tsm-header reveal">
        <span className="tsm-badge">Social Proof</span>
        <h2 className="tsm-title">What Our Clients <em>Say About Us</em></h2>
      </div>

      <div className="tsm-carousel reveal-scale">
        <div className="tsm-slide" key={index}>
          <span className="tsm-quote-mark" aria-hidden="true">❝</span>
          <blockquote>{active.quote}</blockquote>
          <div className="tsm-person">
            <span className="tsm-avatar">{active.initials}</span>
            <div className="tsm-person-text">
              <strong>{active.name}</strong>
              <small>{active.role}</small>
            </div>
          </div>
          <div className="tsm-stars" aria-label={`${active.rating} out of 5 stars`}>
            {Array.from({ length: 5 }).map((_, i) => (
              <span key={i} className={i < active.rating ? 'star-filled' : 'star-empty'}>★</span>
            ))}
          </div>
        </div>
      </div>

      <div className="tsm-controls">
        <button type="button" className="tsm-nav" onClick={prev} aria-label="Previous testimonial">‹</button>
        <div className="tsm-dots">
          {testimonials.map((_, i) => (
            <button
              key={i}
              type="button"
              className={`tsm-dot ${i === index ? 'active' : ''}`}
              aria-label={`Go to testimonial ${i + 1}`}
              onClick={() => setIndex(i)}
            />
          ))}
        </div>
        <button type="button" className="tsm-nav" onClick={next} aria-label="Next testimonial">›</button>
      </div>

      <div className="tsm-cta reveal">
        <a href="#/testimonials" className="tsm-cta-btn">View All Success Stories →</a>
      </div>
    </section>
  );
}
